import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import CountdownBar from "@/components/CountdownBar";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Benefits from "@/components/Benefits";
import WhatsInside from "@/components/WhatsInside";
import Testimonials from "@/components/Testimonials";
import Pricing from "@/components/Pricing";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F2] text-[#1A241E]" data-testid="landing-page">
      <div className="grain-overlay" />
      <div className="fixed top-0 inset-x-0 z-50">
        <CountdownBar />
        <Navbar />
      </div>
      <main>
        <Hero />
        <Marquee />
        <Benefits />
        <WhatsInside />
        <Testimonials />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
